module.exports = __webpack_public_path__ + "img/state2.a3bbd759.webp";